import React, { Component, Fragment } from 'react';
import { formatMoney } from '../../../../../../helpers/functions';
import { DATE_TIME_FORMAT, ORDER, SALE_CHANNELS, PAYMENTS_GATEWAY, INSTALLMENT as INSTALLMENT_ENUM } from '../../../../../../constants/Define';
import { FormWrapperInputComponent, FormWrapperItem, StatusComponent } from "../../../../common/component/Index";
import Wrapper from "../../../../common/component/Wrapper";
import Dropdown from "../../../../common/component/Dropdown";
import Button from "../../../../common/component/Button";
import TextArea from "../../../../common/component/TextArea";
import Input, { InputGroup } from "../../../../common/component/Input";
import FontIcon, { SolidIcons } from "../../../../common/component/FontIcon";
import AntSelect, { AntOption } from '../../../../common/component/AntSelect'
import { Skeleton, Descriptions, Icon, Menu, Tooltip, Popover, message } from 'antd';
import * as Func from '../../../../../../helpers/functions';
import Order, { OrderUpdateStatus } from '../../../../../../models/Order';

import './OrderInfo.less';
import { getLocaleFullName, getKeyByValue } from '../../../../../../utils/commonUtils';
import Ripple from '../../../../common/component/Ripple';

import { cloneDeep, isEqual, find, get } from 'lodash';
import Span from '../../../../common/component/Span';
import EllipsisText from '../../../../common/component/EllipsisText';
import Modal from "../../../../common/component/Modal";
import { retryCiapsBooking } from '../../../../../../services/orderService';


let orderOnline = ['onepay', 'vnpay', 'onepay_installment', 'qrcode']
export default class OrderInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            editingAccountingStatus: false,
            orderEditing: new Order(),
            transactionId: '',
            itemSelected: false,
            openCopy: false,
            isRetryingCiapsBooking: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.order && (!isEqual(this.props.order, prevProps.order)
            || (!isEqual(this.props.orderState.isFetchingUpdateOrderStatus, prevProps.orderState.isFetchingUpdateOrderStatus)))) {
            this.setState({ editing: false, orderEditing: cloneDeep(this.props.order) });
        }
    }

    // isAllTourOrderItemNotSuccess() {
    //     const { orderItem } = this.props;
    //     let result = false;
    //     if (orderItem && orderItem.tours && orderItem.tours.length > 0) {
    //         const totalOrderItems = orderItem.tours.length;
    //         const totalOrderItemNotSuccess = orderItem.tours.filter(item => {
    //             return item && (item.status === ORDER.ORDER_ITEM_STATUS_OBJ.FAILED);
    //         });
    //         result = totalOrderItems === totalOrderItemNotSuccess.length;
    //     }
    //     return result;
    // }

    isAllOrderItemNotSuccess(type) {
        const { orderItem, reservations } = this.props;
        const items = type === 'TOUR' ? orderItem.tours : reservations
        const keyStatus = type === 'TOUR' ? 'status' : 'orderStatus'
        let result = false;
        if ((orderItem || reservations) && items && items.length > 0) {
            const totalOrderItems = items.length;
            const totalOrderItemNotSuccess = items.filter(item => {
                return item && (item[keyStatus] === ORDER.ORDER_ITEM_STATUS_OBJ.FAILED);
            });
            result = totalOrderItems === totalOrderItemNotSuccess.length;
        }
        return result;
    }

    allowShowRecommitButton() {
        const { order, permisions } = this.props;
        const { editing } = this.state;
        const isTwoItemTypeOnly = order && order.itemTypes && order.itemTypes.length === 1 && (order.itemTypes.includes(ORDER.TYPES.TOUR.id) || order.itemTypes.includes(ORDER.TYPES.HOTEL.id));
        return permisions.allowRecommit && 
                isTwoItemTypeOnly && 
                (this.isAllOrderItemNotSuccess('TOUR') || this.isAllOrderItemNotSuccess('HOTEL')) && 
                !editing && 
                (order.paymentStatus === ORDER.PAYMENT_STATUS_OBJ.PAID)
            && (order.status === ORDER.ORDER_STATUS_OBJ.FAILED);
    }

    onClickRetryCiapsBooking = () => {
        const { t, order, getOrderDetail } = this.props;
        if (this.state.isRetryingCiapsBooking) return;
        this.setState({ isRetryingCiapsBooking: true });
        retryCiapsBooking(order.id).then(result => {
            this.setState({ isRetryingCiapsBooking: false });
            const body = get(result, 'data') || {};
            if (body.isSuccess !== true) {
                return this.showRetryCiapsBookingError(body);
            }
            message.success({ content: t('item.order.retryCiapsBookingSuccess'), duration: 5 });
            getOrderDetail && getOrderDetail(order.id);
        }).catch(e => {
            this.setState({ isRetryingCiapsBooking: false });
            this.showRetryCiapsBookingError(e);
        });
    }

    showRetryCiapsBookingError = (error) => {
        const { t } = this.props;
        const code = get(error, 'errors[0].code') || 'SYS';
        const errorMessage = t(`item.order.retryCiapsBookingErrors.${ code }`);
        const content = errorMessage.endsWith(code)
            ? (get(error, 'errors[0].message') || get(error, 'message') || t('item.order.retryCiapsBookingErrors.SYS'))
            : errorMessage;
        message.error({ content, duration: 5 });
    }

    onClickReCommitBtn() {
        const { t, recommitTourOrder, order } = this.props;
        const orderId = order.id;
        const { confirm } = Modal;
        confirm({
            title: t(`item.order.confirmRecommitTour`),
            content: order.orderCode,
            okText: t(`action.send`),
            cancelText: t(`action.cancel`),
            onOk: () => {
                recommitTourOrder && recommitTourOrder(orderId)
            },
        });
    }

    onClickReCommitHotelBundleBtn(){
        this.setState({ itemSelected: true })
    }
    
    confirmRemove = ()=>{
        const { recommitHotelBundle, order } = this.props;
        const orderId = order.id;
        if(!this.state.transactionId) {
            return message.error('Vui lòng nhập mã giao dịch!')
        }
        recommitHotelBundle && recommitHotelBundle({orderId: orderId, transactionId: this.state.transactionId})
        this.handleCloseModal()
    }

    handleCloseModal = ()=>{
        this.setState({ itemSelected: false, transactionId: '' })
    }

    parseMoneyValue(value) {
        const moneyValue = Number(`${value || 0}`.replace(/,/g, ''));
        return Number.isNaN(moneyValue) ? 0 : moneyValue;
    }

    renderMoney(value) {
        const { t } = this.props;
        return `${formatMoney(this.parseMoneyValue(value))} ${t(`currencySymbol`)}`;
    }

    renderAdjustmentMoney(value) {
        const moneyValue = this.parseMoneyValue(value);
        return `${moneyValue > 0 ? '+' : ''}${this.renderMoney(moneyValue)}`;
    }

    renderDiscountValue(code, value) {
        const { t } = this.props;
        const formattedDiscountValue = Math.abs(this.parseMoneyValue(value));
        const discountCode = code || '';

        if (!discountCode && !formattedDiscountValue) {
            return '';
        }

        return `${discountCode} (-${formatMoney(formattedDiscountValue)} ${t(`currencySymbol`)})`.trim();
    }

    renderPaymentPromotion() {
        const { order } = this.props;
        return this.renderDiscountValue(order.promotionBankCode, order.promotionBankValue);
    }

    renderExchangeCash() {
        const { order } = this.props;
        return this.renderMoney(order.exchangeCash);
    }

    // onClickUpdateOrderStatusBtn() {
    //     const { t, updateOrderStatus } = this.props;
    //     const { orderEditing } = this.state;
    //     const orderId = orderEditing.id;
    //     const { confirm } = Modal;
    //     confirm({
    //         title: t(`item.order.confirmUpdateOrderStatus`),
    //         content: orderEditing.orderCode,
    //         okText: t(`action.send`),
    //         cancelText: t(`action.cancel`),
    //         onOk: () => {
    //             updateOrderStatus && updateOrderStatus(new OrderUpdateStatus({id: orderId, status: orderEditing.status}));
    //         },
    //     });
    // }

    render() {
        const { t, order, loading, permisions, orderState, orderGolf } = this.props;
                const { isFetchingRecommit, isFetchingUpdateOrderStatus } = orderState;
        const { editing, editingAccountingStatus, orderEditing, itemSelected, transactionId } = this.state;
        const transactionKey = orderOnline.includes(orderEditing.paymentType) ? 'id' : 'transactionId'
        delete PAYMENTS_GATEWAY.PAYLATER
        return (
            <Wrapper className="order-info-section col-md-12 mb-3">
                <h3 className={ `ml-0` }>{ t('item.order.orderInfo') }</h3>
                <Wrapper className={ `row mt-2` }>
                    { !loading ?
                        <div className="order-info-grid w100-percent">
                            <div className="row">
                                <div className="col-md-6 col-12 mb-4">
                                    <div className="info-group-card">
                                        <Descriptions bordered className="white-bg info-group-table" column={1} size="small" title={t('item.order.groupOrderInfo')}>
                                            <Descriptions.Item label={ t('item.order.orderCode') }>
                                                <div className='orderId'>
                                                    {order.orderCode}
                                                    {order.itemTypes == '9' && (
                                                        <div>
                                                            Đơn hàng gốc:
                                                            <a href={order.parentOrderCode.id} target='_blank'>
                                                                {order.parentOrderCode.code}
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            </Descriptions.Item>
                                            {
                                                order.itemTypes && order.itemTypes.includes(11) && (
                                                    <Descriptions.Item label={ this.renderRequiredLabel(t('item.order.bookingId')) }>
                                                        { orderGolf?.golfSoftOrderCode }
                                                    </Descriptions.Item>
                                                )
                                            }
                                            <Descriptions.Item label={ t('item.order.createdDate') }>
                                                { order.createdDate && order.createdDate.format(DATE_TIME_FORMAT.DATE_TIME) }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.status') }>
                                                { this.renderOrderStatus('status', 'ENUM_ORDER_STATUS', 'orderStatus') }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.accountantStatus') }>
                                                <div className='flex-center'>
                                                    { this.renderAccountingStatus('accountantStatus', 'ORDER_STATUS_OBJ', 'orderStatus') }

                                                    {
                                                        !(order.itemTypes && order.itemTypes.includes(11)) &&
                                                        <Ripple waitForEffect={ true } className={ `btn-edit p-1 mr-1 ml-2 text-nowrap` } onClick={ !editingAccountingStatus ? this.onClickEditAccountingStatus : this.onClickCancelAccountingStatus }
                                                            disabled={!permisions || !permisions.allowChangeAccountingStatus }><Icon
                                                            type={ editingAccountingStatus ? 'close' : 'edit' }/> { editingAccountingStatus ? t(`action.cancel`) : t(`action.edit`) }
                                                        </Ripple>
                                                    }
                                                    { editingAccountingStatus &&
                                                    <Ripple waitForEffect={ true } className={ `btn-save p-1 text-nowrap` } disabled={ loading || !permisions || !permisions.allowChangeAccountingStatus }
                                                        onClick={ this.onClickSaveAccountingStatus }><Icon
                                                        type='save'/> { t(`action.save`) }
                                                    </Ripple> }
                                                </div>
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.channel') }>
                                                { t(`item.order.channels.${order.channel}`) }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ this.labelRequired('saleChannel') }>
                                                { this.renderSelectEnum('saleChannel', 'saleChannels', SALE_CHANNELS) }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.note') }>
                                                <div>{ this.renderNote() }</div>
                                            </Descriptions.Item>
                                            {order.affSource !== 'original' && (
                                                <Descriptions.Item label={t('item.order.affSource_affSId')}>
                                                    <div>{order.affSource} / {order.affSID}</div>
                                                </Descriptions.Item>
                                            ) }
                                            {order.itemTypes == '4' && (
                                                <Fragment>
                                                    {/* <Descriptions.Item label={t('item.order.crossSellOlder')} >
                                                        <div className='crossSellOrder'>
                                                            {order.childOrderCodes.map((item, index) => (
                                                                <Fragment key={index}>
                                                                    <a href={item.id} target='_blank'>
                                                                        {item.code}
                                                                    </a>
                                                                    {index !== order.childOrderCodes.length - 1 && ', '}
                                                                </Fragment>
                                                            ))}
                                                        </div>
                                                    </Descriptions.Item> */}
                                                    <Descriptions.Item label={t('item.order.crossSellLink')} >
                                                        {order.status != '1' && this.renderCrossSellLink()}
                                                    </Descriptions.Item>
                                                </Fragment>
                                            ) }
                                            { !!order.errors.length && (
                                                <Descriptions.Item label={ t('item.order.orderError') }>
                                                    <div className="order-error-text">{ this.renderOrderError() }</div>
                                                </Descriptions.Item>
                                            ) }
                                        </Descriptions>
                                    </div>
                                </div>

                                <div className="col-md-6 col-12 mb-4">
                                    <div className="info-group-card">
                                        <Descriptions bordered className="white-bg info-group-table" column={1} size="small" title={t('item.order.groupCustomerInfo')}>
                                            <Descriptions.Item label={ this.renderRequiredLabel(t('item.order.fullName')) }>
                                                { this.renderFullName() }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ this.renderRequiredLabel(t('item.order.phoneNumber')) }>
                                                { this.renderPhoneNumber() }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ this.renderRequiredLabel(t('item.order.email')) }>
                                                { this.renderEmail() }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.memberShipName') } >
                                                <div>{ `${order.memberShipLastname} ${order.memberShipFirstname}`.trim() }</div>
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.vgId') } >
                                                <div>{ order.vgId }</div>
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.memberShipCode') } >
                                                <div>{ order.memberShipCode }</div>
                                            </Descriptions.Item>
                                        </Descriptions>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 col-12 mb-4">
                                    <div className="info-group-card">
                                        <Descriptions bordered className="white-bg info-group-table" column={1} size="small" title={t('item.order.groupPaymentInfo')}>
                                            
                                            <Descriptions.Item label={ this.labelRequired('paymentType') }>
                                                { this.renderSelectEnum('paymentType', 'paymentTypes', PAYMENTS_GATEWAY) }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.paymentMethod') }>
                                                { order.paymentMethod || '-' }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.paymentStatus') }>
                                                { this.renderPaymentStatus('paymentStatus', 'ENUM_PAYMENT_STATUS', 'paymentStatusEnum') }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t(`item.order.transactionId`) }>
                                                { this.renderTextRequired(transactionKey) }
                                            </Descriptions.Item>
                                            {
                                                order.paymentType === 'onepay_installment' &&
                                                <Fragment>
                                                    <Descriptions.Item label={ t('item.order.installmentFee') }>
                                                        { order.installmentFee && this.props.t(`item.group.installmentFee_enum.${ order.installmentFee }`) }
                                                    </Descriptions.Item>
                                                    <Descriptions.Item label={ t('item.order.installmentLimit') }>
                                                        { order.installmentLimit && this.props.t(`item.group.installmentLimit_enum.${ getKeyByValue(INSTALLMENT_ENUM.INSTALLMENT_LIMIT, order.installmentLimit) }`) }
                                                    </Descriptions.Item>
                                                </Fragment>
                                            }
                                        </Descriptions>
                                    </div>
                                </div>

                                <div className="col-md-6 col-12 mb-4">
                                    <div className="info-group-card">
                                        <Descriptions bordered className="white-bg info-group-table" column={1} size="small" title={t('item.order.groupFinancialInfo')}>
                                            <Descriptions.Item label={ t('item.order.totalOriginalAmount') }>
                                                { this.renderMoney(order.totalOriginalAmount || order.subTotalBeforePromotion) }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.coupon') }>
                                                { this.renderDiscountValue(order.couponCode, order.couponValue) }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.exchangeCash') }>
                                                { this.renderExchangeCash() }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.paymentPromotion') }>
                                                { this.renderPaymentPromotion() }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.totalPayment') }>
                                                { this.renderMoney(order.totalPayment) }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.totalChangeRateCodeAdmin') }>
                                                { this.renderAdjustmentMoney(order.totalChangeRateCode) }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.totalSurchargeAdmin') }>
                                                { this.renderAdjustmentMoney(order.itemTypes && order.itemTypes.includes(11) ? orderGolf?.totalSurchargeFee : order.totalSurcharge) }
                                            </Descriptions.Item>
                                            <Descriptions.Item label={ t('item.order.totalAmountAdmin') }>
                                                { this.renderMoney(order.totalAmount) }
                                            </Descriptions.Item>
                                        </Descriptions>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : <Skeleton active paragraph={ { row: 7 } }/>
                    }
                </Wrapper>
                { permisions && permisions.allowUpdate &&
                <Wrapper className={ `editing-buttons ${ editing ? 'editing' : '' } flex-center` }>
                    { this.renderSendEmailTemplate() }
                    {/* {(order.status === 2 || order.status === 9) && <Ripple waitForEffect={true} className={`btn-edit p-1 mr-1 ml-2`} onClick={this.createSurcharge}><Icon type={'edit'} />{t(`action.newSurchange`)}</Ripple>} */ }
                    <Ripple waitForEffect={ true } className={ `btn-edit p-1 mr-1 ml-2` } onClick={ !editing ? this.onClickEdit : this.onClickCancel }
                            disabled={ isFetchingRecommit || isFetchingUpdateOrderStatus }><Icon
                        type={ editing ? 'close' : 'edit' }/> { editing ? t(`action.cancel`) : t(`action.edit`) }</Ripple>
                    { editing &&
                    <Ripple waitForEffect={ true } className={ `btn-save p-1` } disabled={ loading || isEqual(orderEditing, order) || isFetchingRecommit || isFetchingUpdateOrderStatus }
                            onClick={ this.onClickSave }><Icon
                        type='save'/> { t(`action.save`) } </Ripple> }
                </Wrapper>
                }
                <Modal
                    title={t('item.order.confirmRecommitHotelBundle')} 
                    visible={!!itemSelected}
                    width={400}
                    onOk={this.confirmRemove} 
                    onCancel={this.handleCloseModal}
                    okText={t('action.confirm')}
                    closable={false}
                >
                    <Fragment>
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            labelTitle={t(`item.order.transactionHotelBundle`)}
                        >
                            <Input type="text"
                                autoComplete="off"
                                className="form-control" name="transactionId" onChange={(e) => this.setState({ transactionId: e.target.value })}
                                value={transactionId} />
                        </FormWrapperInputComponent>
                    </Fragment>
                </Modal>
            </Wrapper>
        );
    }

    // createSurcharge = () => {
    //     this.props.openModalDetail();
    // }

    labelRequired = (field) => {
        const { t } = this.props;
        return (this.props.order.paymentType !== 'vnpay' || this.props.order.paymentType !== 'onepay' || this.props.order.paymentType !== 'qrcode') ? this.renderRequiredLabel(t(`item.order.${ field }`)) : t(`item.order.${ field }`);
    }

    renderTextRequired(field) {
        const { t, order, validation } = this.props;
        const { editing, orderEditing } = this.state;
        return (editing && order.paymentType !== 'vnpay' && order.paymentType !== 'onepay' && order.paymentType !== 'qrcode' && !(order.itemTypes && order.itemTypes.includes(11))
                ? <Wrapper className={ !!validation[field] ? 'validate-failed' : '' }>
                    <Input value={ orderEditing[field] }
                           placeholder={ t(`item.order.${ field }`) }
                           onChange={ e => this.onChangeEditing(field, e.target.value) }/>
                    { this.renderErrorMessage(validation[field]) }
                </Wrapper>
                : order[field]
        )
    }

    renderRequiredLabel(label) {
        const {  order } = this.props;
        const { editing } = this.state;
        return ((editing && !(order.itemTypes && order.itemTypes.includes(11))) || (label === "Thư điện tử" && editing && (order.itemTypes && order.itemTypes.includes(11)))) ? (
            <Fragment>{ label }<Span style={ { color: 'red' } }>{ '*' }</Span></Fragment>
        ) : label;
    }

    renderErrorMessage(error) {
        return error && error.messageError && <Wrapper className="error-message"><Span>{ error.messageError }</Span></Wrapper>
    }

    renderFullName() {
        const { t, order, validation } = this.props;
        const { editing, orderEditing } = this.state;        
        return (editing && !(order.itemTypes && order.itemTypes.includes(11))
                ? <Wrapper className={ !!(validation.lastname || validation.firstname) ? 'validate-failed' : '' }>
                    <InputGroup compact>
                        <Input style={ { width: '50%' } } value={ orderEditing.lastname }
                               placeholder={ t(`item.user.lastname`) }
                               onChange={ e => this.onChangeEditing('lastname', e.target.value) }/>
                        <Input style={ { width: '50%' } } value={ orderEditing.firstname }
                               placeholder={ t(`item.user.firstname`) }
                               onChange={ e => this.onChangeEditing('firstname', e.target.value) }/>
                    </InputGroup>
                    { this.renderErrorMessage(validation.lastname || validation.firstname) }
                </Wrapper>
                : (order.fullname || getLocaleFullName(order.firstname, order.lastname))
        )
    }

    renderPhoneNumber() {
        const { t, order, validation } = this.props;
        const { editing, orderEditing } = this.state;
        return (editing && !(order.itemTypes && order.itemTypes.includes(11))
                ? <Wrapper className={ !!validation.phoneNumber ? 'validate-failed' : '' }>
                    <Input value={ orderEditing.phoneNumber }
                           placeholder={ t(`item.order.phoneNumber`) }
                           onChange={ e => this.onChangeEditing('phoneNumber', e.target.value) }/>
                    { this.renderErrorMessage(validation.phoneNumber) }
                </Wrapper>
                : order.phoneNumber
        )
    }

    renderEmail() {
        const { t, order, validation } = this.props;
        const { editing, orderEditing } = this.state;
        return (editing
                ? <Wrapper className={ !!validation.email ? 'validate-failed' : '' }>
                    <Input value={ orderEditing.email }
                           placeholder={ t(`item.order.email`) }
                           onChange={ e => this.onChangeEditing('email', e.target.value) }/>
                    { this.renderErrorMessage(validation.email) }
                </Wrapper>
                : order.email
        )
    }

    renderCustomerLoginInfo(customerLoginInfo) {
        if (!customerLoginInfo) return null;
        if (typeof customerLoginInfo !== 'object') return customerLoginInfo;

        const fullName = customerLoginInfo.fullName || customerLoginInfo.fullname ||
            getLocaleFullName(customerLoginInfo.firstName || customerLoginInfo.firstname, customerLoginInfo.lastName || customerLoginInfo.lastname);
        const phoneNumber = customerLoginInfo.phoneNumber || customerLoginInfo.phone;
        const email = customerLoginInfo.email;
        const memberShipCode = customerLoginInfo.memberShipCode || customerLoginInfo.membershipCode;
        const infoItems = [fullName, phoneNumber, email, memberShipCode].filter(Boolean);

        if (!infoItems.length) return JSON.stringify(customerLoginInfo);

        return (
            <Fragment>
                {infoItems.map((item, index) => <div key={index}>{item}</div>)}
            </Fragment>
        );
    }

    renderOrderStatus(stateName, enumName, langName) {
        const { order, orderState, permisions } = this.props;
        const { editing } = this.state;
        const { detail } = orderState;
        const { flight, reservations, orderItem } = detail;
        const enumStatusArr = Object.keys(ORDER[enumName]);
        const itemTypes = order.itemTypes;
        const flightRoundTripStatusIsSuccess = itemTypes.includes(ORDER.TYPES.FLIGHT.id)
            ? (flight && (flight.departureOrderStatus === ORDER.ORDER_ITEM_STATUS_OBJ.SOLD || flight.departureOrderStatus === ORDER.ORDER_ITEM_STATUS_OBJ.USED) && (flight.returnOrderStatus === ORDER.ORDER_ITEM_STATUS_OBJ.SOLD || flight.returnOrderStatus === ORDER.ORDER_ITEM_STATUS_OBJ.USED)) : true;
        let totalItemHasSold = 0;
        const flightItemTypeOnly = itemTypes.length === 1 && itemTypes.includes(ORDER.TYPES.FLIGHT.id);
        const orderItemVinWonder = orderItem.vinWonders.reduce((a, b) => a + b.bookingItems.length, 0)
        const totalItems = orderItem && reservations ? (orderItem.tours.length + orderItemVinWonder + orderItem.vouchers.length + reservations.length) : 0;
        let totalItemRecords = reservations;
        Object.entries(orderItem).map(([key, value]) => {
            // if ([ORDER.TYPES.VOUCHER.key, ORDER.TYPES.VINWONDER.key, ORDER.TYPES.TOUR.key].includes(key)) {
            //     totalItemRecords.concat(value)
            // }
            if (ORDER['TYPE_ITEM_TOTAL'].includes(key)) {
                if(key === 'vinWonders') {
                    let itemVinWonder = []
                    value.forEach(val => {
                        itemVinWonder = [...itemVinWonder, ...val.bookingItems]
                    })
                    totalItemRecords = [...totalItemRecords, ...itemVinWonder]
                } else {
                    totalItemRecords = [...totalItemRecords, ...value]
                }
            }
        })
        totalItemHasSold = totalItemRecords.filter(item => {
            return item && (item.status === ORDER.ORDER_ITEM_STATUS_OBJ.SOLD || item.orderStatus === ORDER.ORDER_ITEM_STATUS_OBJ.SOLD || item.status === ORDER.ORDER_ITEM_STATUS_OBJ.USED || item.orderStatus === ORDER.ORDER_ITEM_STATUS_OBJ.USED);
        }).length;

        // cho phép trạng thái chờ xử lý sang thành công 
        const allowEdit = editing && 
            (order.paymentStatus === ORDER.PAYMENT_STATUS_OBJ.PAID && (order.status === ORDER.ORDER_STATUS_OBJ.FAILED || order.status === ORDER.ORDER_STATUS_OBJ.WAITING)) && 
            flightRoundTripStatusIsSuccess && 
            (flightItemTypeOnly || (!flightItemTypeOnly && totalItems > 0 && totalItems === totalItemHasSold)) && 
            permisions.allowUpdateStatus;
        const allowShowRecommitBtn = this.allowShowRecommitButton();
        return this.renderStatusComponent(allowEdit, enumStatusArr, stateName, enumName, langName, allowShowRecommitBtn);
    }

    renderPaymentStatus(stateName, enumName, langName) {
        const enumStatusArr = Object.keys(ORDER[enumName]);
        const { editing } = this.state;
        return this.renderStatusComponent(editing, enumStatusArr, stateName, enumName, langName);
    }

    renderStatusComponent(editing, enumStatusArr, stateName, enumName, langName, isShowRecommitBtn = false) {
        const { t, order, orderState, orderItem, permisions } = this.props;
        const { isFetchingRecommit, isFetchingUpdateOrderStatus } = orderState;
        const { orderEditing, isRetryingCiapsBooking } = this.state;
        const hasSoldVinWonderItem = (orderItem?.vinWonders || []).some(item =>
            (item.bookingItems || []).some(bookingItem => bookingItem.status === ORDER.ORDER_ITEM_STATUS_OBJ.SOLD)
        );
        return (editing && !(order.itemTypes && order.itemTypes.includes(11))
                ? (
                    <Wrapper className="order-status">
                        <AntSelect className="select-enum"
                                   showArrow showSearch
                                   placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t(`item.order.${ stateName }`)).toLowerCase()) }
                                   value={ orderEditing[stateName] ? t(`item.order.${ langName }.${ orderEditing[stateName] }`) : null }
                                   onChange={ (e) => this.onChangeEditing(stateName, e) }
                                   style={ { width: '100%' } }
                                   filterOption={ this.selectFilterSearch }
                        >
                            <AntOption key={ order[stateName] }
                                       value={ order[stateName] }>{ t(`item.order.${ langName }.${ order[stateName] }`) + ` ( ${ t('item.order.currentStatus') } )` }</AntOption>
                            { enumStatusArr.map(item =>
                                (ORDER[enumName][item].showOn).includes(order[stateName]) &&
                                <AntOption key={ item } value={ ORDER[enumName][item].value }>{ t(`item.order.${ langName }.${ ORDER[enumName][item].value }`) }</AntOption>
                            ) }
                        </AntSelect>
                    </Wrapper>
                )
                : (
                    <Fragment>
                        <StatusComponent color={ ORDER['COLOR_ORDER_STATUS'][order[stateName]] || 'red' }
                                         label={ t(`item.order.${ langName }.${ order[stateName] }`) }/>
                        { isShowRecommitBtn &&
                        <Fragment>
                            <Button className="btn btn-primary ml-3" onClick={ () => this.onClickReCommitBtn() } disabled={ isFetchingRecommit || isFetchingUpdateOrderStatus }>
                                { t(`item.order.recommit`) }
                            </Button>
                        </Fragment> }
                        { enumName === 'ENUM_ORDER_STATUS' && order.canRetryCiapsBooking && !hasSoldVinWonderItem &&
                        <Button className="btn btn-primary ml-3 btn-retry-ciaps-booking" icon="reload"
                                loading={ isRetryingCiapsBooking }
                                disabled={ isRetryingCiapsBooking || isFetchingRecommit || isFetchingUpdateOrderStatus }
                                onClick={ this.onClickRetryCiapsBooking }>
                            { t(`item.order.retryCiapsBooking`) }
                        </Button> }
                        { order.isRecommitHotelBundle && permisions.allowRecommit && enumName === 'ENUM_ORDER_STATUS' && 
                            <Fragment>
                                <Button className="btn btn-primary ml-3" onClick={ () => this.onClickReCommitHotelBundleBtn() } disabled={ isFetchingRecommit || isFetchingUpdateOrderStatus }>
                                    { t(`item.order.recommitHotelBundle`) }
                                </Button>
                            </Fragment> }
                    </Fragment>

                )
        )
    }

    renderAccountingStatus(stateName, enumName, langName) {
        const enumStatusArr = Object.keys(ORDER[enumName]);
        const { editingAccountingStatus } = this.state;
        return this.renderAccountingStatusComponent(editingAccountingStatus, enumStatusArr, stateName, enumName, langName);
    }

    renderAccountingStatusComponent(editing, enumStatusArr, stateName, enumName, langName, isShowRecommitBtn = false) {
        const { t, order, orderState, permisions } = this.props;
        const { orderEditing } = this.state;
        return (editing
                ? (
                    <Wrapper className="order-status">
                        <AntSelect className="select-enum"
                                   showArrow showSearch
                                   placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t(`item.order.${ stateName }`)).toLowerCase()) }
                                   value={ orderEditing[stateName] ? t(`item.order.${ langName }.${ orderEditing[stateName] }`) : null }
                                   onChange={ (e) => this.onChangeEditing(stateName, e) }
                                   style={ { width: '100%', minWidth: 150 } }
                                   filterOption={ this.selectFilterSearch }
                        >
                            { enumStatusArr.map(item =>
                                <AntOption key={ item } value={ ORDER[enumName][item] }>{ t(`item.order.${ langName }.${ ORDER[enumName][item] }`) }</AntOption>
                            ) }
                        </AntSelect>
                    </Wrapper>
                )
                : (
                    <Fragment>
                        <StatusComponent color={ ORDER['COLOR_ORDER_STATUS'][order[stateName]] || 'red' }
                                         label={ t(`item.order.${ langName }.${ order[stateName] }`) }/>
                        { isShowRecommitBtn &&
                        <Fragment>
                            <Button className="btn btn-primary ml-3" onClick={ () => this.onClickReCommitBtn() }>
                                { t(`item.order.recommit`) }
                            </Button>
                        </Fragment> }
                        { order.isRecommitHotelBundle && permisions.allowRecommit && enumName === 'ENUM_ORDER_STATUS' && 
                            <Fragment>
                                <Button className="btn btn-primary ml-3" onClick={ () => this.onClickReCommitHotelBundleBtn() }>
                                    { t(`item.order.recommitHotelBundle`) }
                                </Button>
                            </Fragment> }
                    </Fragment>

                )
        )
    }

    // renderPaymentStatus() {
    //     const { t, order, validation } = this.props;
    //     const { editing, orderEditing } = this.state;
    //     return (editing && order.paymentStatus === ORDER.STATUS.WAITING
    //         ? (
    //             <Wrapper className="order-status">
    //                 <Span className="flex-center">
    //                     <Checkbox className="mr-1" checked={orderEditing.paymentStatus === ORDER.STATUS.PAID}
    //                         onChange={e => {
    //                             const paymentStatus = e.target.checked ? ORDER.STATUS.PAID : ORDER.STATUS.UNPAID;
    //                             this.onChangeEditing('paymentStatus', paymentStatus);
    //                         }} />
    //                     {t(`item.order.paymentStatusEnum.2`)}
    //                 </Span>
    //             </Wrapper>
    //         )
    //         : <StatusComponent color={order.paymentStatus === 2 ? 'green' : order.paymentStatus === 4 ? 'blue' : 'red'}
    //             label={t(`item.order.paymentStatusEnum.${order.paymentStatus}`)} />
    //     )
    // }

    // renderPaymentStatus() {
    //     const { t, order, validation } = this.props;
    //     const { editing, orderEditing } = this.state;
    //     return (editing && order.paymentStatus === ORDER.STATUS.WAITING
    //         ? (
    //             <Wrapper className="order-status">
    //                 <Span className="flex-center">
    //                     <Checkbox className="mr-1" checked={orderEditing.paymentStatus === ORDER.STATUS.PAID}
    //                         onChange={e => {
    //                             const paymentStatus = e.target.checked ? ORDER.STATUS.PAID : ORDER.STATUS.UNPAID;
    //                             this.onChangeEditing('paymentStatus', paymentStatus);
    //                         }} />
    //                     {t(`item.order.paymentStatusEnum.2`)}
    //                 </Span>
    //             </Wrapper>
    //         )
    //         : <StatusComponent color={order.paymentStatus === 2 ? 'green' : order.paymentStatus === 4 ? 'blue' : 'red'}
    //             label={t(`item.order.paymentStatusEnum.${order.paymentStatus}`)} />
    //     )
    // }

    renderSelectEnum(field, fieldTextEnum, enumList) {
        const { t, order, validation } = this.props;
        const { editing, orderEditing } = this.state;
        return (editing && !orderOnline.includes(order.paymentType) && !(order.itemTypes && order.itemTypes.includes(11))
                ? (
                    <Wrapper className={ !!validation[field] ? 'validate-failed' : '' }>
                        <AntSelect className="select-enum"
                                   showArrow showSearch
                                   placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t(`item.order.${ field }`)).toLowerCase()) }
                                   value={ orderEditing[field] ? t(`item.order.${ fieldTextEnum }.${ orderEditing[field] }`) : null }
                                   onChange={ (e) => this.onChangeEditing(field, e) }
                                   style={ { width: '100%' } }
                                   filterOption={ this.selectFilterSearch }
                        >
                            { Object.keys(enumList).map(item => (
                                <AntOption key={ item } value={ enumList[item] }>{ t(`item.order.${ fieldTextEnum }.${ enumList[item] }`) }</AntOption>
                            )) }
                        </AntSelect>
                        { this.renderErrorMessage(validation[field]) }
                    </Wrapper>
                )
                : field !== 'paymentType' ? order[field] && t(`item.order.${ fieldTextEnum }.${ order[field] }`) : this.rendePayment(order[field])
        )
    }


    rendePayment(curPayment) {
        const { t } = this.props;

        return (
            curPayment && <StatusComponent color={ 'gray' } label={ t(`item.order.paymentTypes.${ curPayment }`) }/>
        )
    }

    renderNote() {
        const { t, order } = this.props;
        const { editing, orderEditing } = this.state;
        return (editing && !(order.itemTypes && order.itemTypes.includes(11))
                ? <TextArea value={ orderEditing.note }
                            placeholder={ t(`item.order.note`) }
                            onChange={ e => this.onChangeEditing('note', e.target.value) }/>
                : order.note
        )
    }

    renderOrderError() {
        const { order } = this.props;
        return (
            <Wrapper>
                { order.errors.map((item, index) => {
                    const error = `${ item.code }: ${ item.message }`
                    return <Wrapper key={ index } style={ { marginTop: index !== 0 && 10 } }>
                        { error }
                    </Wrapper>
                }) }
            </Wrapper>
        )
    }

    renderSendEmailTemplate() {
        const { t, emailTemplates, order, loadingEmail, orderState } = this.props;
        const { isFetchingRecommit } = orderState;
        return (!!emailTemplates.length && order.status === ORDER.STATUS.UNPAID && !order.emailHistories.length &&
            <Dropdown disabled={ loadingEmail || isFetchingRecommit } overlay={
                <Menu onClick={ this.onSendTemplateEmail }>
                    { emailTemplates.map(email => <Menu.Item disabled={ loadingEmail } key={ email.id }>
                        <EllipsisText className="flex-center email-template-item"
                                      title={ email.title }
                                      content={ email.title }
                                      contentMaxWidth={ 400 }
                                      overlayClassName={ 'max-width-500' }
                                      overlayComponent={ Tooltip }/>
                    </Menu.Item>) }
                </Menu>
            }>
                <Button type="dashed" disabled={ loadingEmail }>
                    { loadingEmail
                        ? <Icon type="loading"/>
                        : <Icon component={ () => <FontIcon icon={ SolidIcons.faMailBulk }/> }/> } { t(`action.send`) + ' ' + t(`item.emailTemplate.title`).toLowerCase() }
                </Button>
            </Dropdown>
        )
    }

    renderCrossSellLink = () => {
        const { order } = this.props;
        const vptDomain = Func.changeDomainToVPTWeb()
        const languageCode = order.languageCode.split('-')[0];
        let currencyCode;
        switch (languageCode){
            case 'vi':
                currencyCode = 'VND';
                break;
            case 'en':
                currencyCode = 'USD';
                break;
            case 'ko':
                currencyCode = 'KRW';
                break;
            case 'zh':
                currencyCode = 'CNY';
                break;
            case 'ru':
                currencyCode = 'RUB';
                break;
            default:
                currencyCode = 'VND';
                break;
        }
        const linkCrosSell = order?.linkCrossSale

        const onCopy = () => {
            navigator.clipboard.writeText(linkCrosSell);
        };

        const handleVisibleChange = (openCopy) => {
            if (openCopy) {
                this.setState({ openCopy: true })
                setTimeout(() => {
                    this.setState({ openCopy: false });
                }, 2000);
            } else {
                this.setState({ openCopy: false });
            }
        };

        return (
            <div className='crossSellLink'>
                <a href={linkCrosSell} target="_blank">
                    {linkCrosSell}
                </a>
                <Popover 
                    content={
                        <span>Đã sao chép</span>
                    }
                    trigger="click"
                    visible={this.state.openCopy}
                    onVisibleChange={handleVisibleChange}
                >
                    <Button
                        className="btn-copy"
                        onClick={onCopy}
                    >
                        <Icon type={'copy'} style={{ fontSize: '20px'}} />
                    </Button>
                </Popover>
            </div>
        )
    }

    onClickEdit = (e) => {
        const orderEditing = cloneDeep(this.props.order);
        this.setState({ editing: !this.state.editing, orderEditing })
    }

    onClickCancel = (e) => {
        const orderEditing = cloneDeep(this.props.order);
        this.setState({ editing: false, orderEditing })
    }

    onClickSave = (e) => {
        const { order } = this.props;
        const orderEditing = this.state.orderEditing;
        orderEditing.isUpdateOrderStatus = !isEqual(order.status, orderEditing.status);
        this.props.onUpdateOrder(orderEditing);
    }

    
    onClickEditAccountingStatus = (e) => {
        const orderEditing = cloneDeep(this.props.order);
        this.setState({ editingAccountingStatus: !this.state.editingAccountingStatus, orderEditing })
    }

    onClickCancelAccountingStatus = (e) => {
        const orderEditing = cloneDeep(this.props.order);
        this.setState({ editingAccountingStatus: false, orderEditing })
    }

    onClickSaveAccountingStatus = (e) => {
        const orderEditing = this.state.orderEditing;
        this.props.onUpdateOrderAccountant(orderEditing);
        this.setState({ editingAccountingStatus: false, orderEditing })
    }

    onChangeEditing = (fieldName, value) => {
        const orderEditing = this.state.orderEditing;
        orderEditing[fieldName] = value;
        this.setState({ orderEditing })
    }

    onSendTemplateEmail = (e) => {
        const { emailTemplates } = this.props;
        const emailTemplate = find(emailTemplates, item => item.id === e.key);
        if (emailTemplate) {
            return this.props.onSendTemplateEmail(emailTemplate)
        }
    }
}

OrderInfo.defaultProps = {
    order: new Order(),
    onUpdateOrder: order => {
    },
    onUpdateOrderAccountant: order => {
    },
    onSendTemplateEmail: emailTemplate => {
    },
    getOrderDetail: id => {
    },
    loading: false,
    permisions: {},
    validation: {},
    emailTemplates: [],
};
